document.addEventListener("DOMContentLoaded", function () {
  const newsletterField = document.querySelector(".newsletter__field");
  const input = newsletterField.querySelector("input");

  if (input.value !== "") {
    newsletterField.classList.add("newsletter__field--focus");
  }

  input.addEventListener("focus", function () {
    newsletterField.classList.add("newsletter__field--focus");
  });
  input.addEventListener("blur", function () {
    if (input.value === "") {
      newsletterField.classList.remove("newsletter__field--focus");
    }
  });
});
